module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parentDetail"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "已上课程"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "contentdetail"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "nameIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "nameContent",
    domProps: {
      "textContent": _vm._s(_vm.obj.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goalIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "goalContent",
    domProps: {
      "textContent": _vm._s(_vm.obj.teachingObjectives)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "passIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "passContent",
    domProps: {
      "textContent": _vm._s(_vm.obj.teachingProcess)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photoIcon"
  }), _vm._v(" "), _c('div', {
    staticClass: "photoContent"
  }, _vm._l((_vm.obj.imageUrl), function(object, index) {
    return _c('img', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.handleClick,
          index: index
        }),
        expression: "{methods:handleClick,index:index}"
      }],
      key: index,
      staticClass: "photodetail",
      attrs: {
        "src": object,
        "alt": ""
      }
    })
  }), 0)])]), _vm._v(" "), _c('div', [_c('VGoBackBtn')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf410534"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Myrecord/courseDetail.vue
// module id = 797
// module chunks = 1